// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1AlNR","col":"styles_col__cQCKE"};